angular.module('impactx.quota').controller('QuotaCtrl', QuotaCtrl);
QuotaCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    '$mdDialog',
    'ConfirmationService',
    'WarningService',
    'ToolbarService'
];

function QuotaCtrl($scope, dataGen, $routeParams, BackService, $mdToast, $mdDialog, ConfirmationService, WarningService, ToolbarService) {
    var ctrl = this;

    ctrl.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };
    ctrl.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.postAsForm($scope, dataObj, "/quota/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    ctrl.checkAndSave = function ($event) {
        var warnings = ctrl.checkWarnings();
        if (warnings.length == 0) {
            return ctrl.save();
        }
        else {
            WarningService.showWarningDialog(ctrl.save, $event, $scope.trns.warning, $scope.trns.saveAnyway,
                $scope.trns.abort, warnings);
        }
    };

    ctrl.checkWarnings = function () {
        var warnings = [];
        if (Math.abs($scope.data.totalQuota.value) < Math.pow(10, -7)) {
            warnings.push($scope.trns.warningCurrentQuotaZero)
        }
        if (Math.abs($scope.data.orgTotalQuota.value) < Math.pow(10, -7)) {
            warnings.push($scope.trns.warningInitialQuotaZero)
        }
        return warnings;
    };

    ctrl.save = function () {
        var dataObj = {
            quota: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/quota/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    dataGen.getData($scope, {id: $routeParams.id}, "/quota/view").then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.checkAndSave,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            },
            {
                label: $scope.trns.synchronize,
                action: synchronize,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: cannotSync, errorsFunction: getSyncError}
                }
            },
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return isEditable() && $scope.data.id > 0;
    }

    function getSyncError() {
        return [$scope.trns.syncError];
    }

    function cannotSync() {
        return !$scope.data.canSync;
    }

    function synchronize() {
        return dataGen.postAsForm({}, {ids: [$scope.data.id]}, "/quota/synchronize").then(function(data) {
            ToastService.openStandardToast(data.trns.syncMessage);
        });
    }
}